module.exports = __webpack_public_path__ + "static/disc.990f3309.png";